module.exports = __webpack_public_path__ + "img/symbol_0.cb5c1620.png";